import { showCartErrorMessage } from 'features/cart/desktop';
import { getQueryStringValue } from 'utilities/browser';
import { utagLinkCart } from 'features/tealium/';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import { cart, cartModel } from '../config';
import PromoCodeTermsAndConditionsLinkTemplate from '../templates/PromoCodeTermsAndConditionsLinkTemplate';
import CartBaseItemView from '../../baseViews/ItemView';
import { GetPromoCodeTerms, DeleteCartPromoCode } from '../../api';

const trackCartEvents = utagLinkCart();
const promoCodeCartSiteMode = [ 'none', 'consumer', 'professional', 'employee' ].includes(
	window.utag_data.user_type.toLowerCase()
);

const PromoCodeTermsAndConditionsLink = CartBaseItemView.extend({
	JSXTemplate: PromoCodeTermsAndConditionsLinkTemplate,
	className: 'promoTermsAndConditionsContainer',
	ui: {
		termsAndConditionsLink: '.jsShowPromoCodeTermsAndConditions'
	},
	events: {
		'click @ui.termsAndConditionsLink': 'showPromoCodeTermsAndConditions'
	},
	initialize () {

		this.listenTo(this.model, 'change', this.render, this);
		this.firstRender = false;

	},
	templateHelpers () {

		return {
			useDefaultTC: !this.model.get('SelectedPromoCode') || this.model.get('promoCodeError'),
			secureSiteURL: window.lp.globals.secureSiteURL,
			showPromoTermsConditions: this.canShowPromoTermsConditions()
		};

	},
	onRender () {

		// Check for query parameter showcoupon, display promo terms if "true" on page load only
		if (this.firstRender === true) {

			this.firstRender = false;
			if (getQueryStringValue('showcoupon') === 'true') {

				this.ui.terms.trigger('click');

			}

		}

		// TODO: Consistent View, SSR HTML
		const $externalCouponCodeError = $('.couponCodeError');
		const promoCodeError = this.model.get('promoCodeError');
		if (promoCodeError.length > 0) {

			$externalCouponCodeError.html(promoCodeError + $('.removePromoCodeDiv').html()).removeClass('hidden');

			$('.couponCodeError button').on('click', (e) => {

				this.removePromoCode(e);

			});

		} else {

			$externalCouponCodeError.html('').addClass('hidden');

		}

	},
	// TODO: remove this duplicate code by using backbone js method
	removePromoCode (e) {

		e.preventDefault();

		const request = DeleteCartPromoCode().then((response) => {

			if (response.operationSuccess) {

				const removedPromoCode = this.model.get('SelectedPromoCode');
				cartModel.update(response);
				if (removedPromoCode) {

					// fire GA event for remove promo code
					trackCartEvents({ eventAction: 'remove-Coupon', eventLabel: removedPromoCode });

					if (promoCodeCartSiteMode) {

						setGenericEvent({
							event_name: 'cart_promo_remove',
							promocode: 'promo code customer removed successfully',
							promocode_value: removedPromoCode
						});

					}

				}

			} else {

				showCartErrorMessage({ response });

			}

		});
		$(cart).trigger('indicateLoad', request);

	},
	onDomRefresh () {

		if (this.model.get('SelectedPromoCode')) {

			this.$el.parent().removeClass('hidden');

		} else {

			this.$el.parent().addClass('hidden');

		}

	},
	canShowPromoTermsConditions () {

		// TODO: Backend doesn't seem to be setting ShowPromoTermsConditions flag correctly when no promo code error
		// Update this logic to just return this flag directly when that is fixed
		if (this.model.get('promoCodeError')) {

			if (this.model.get('ShowPromoTermsConditions')) {

				return true;

			}

			return false;

		}

		return true;

	},
	showPromoCodeTermsAndConditions (e) {

		const that = this;
		e.preventDefault();
		$('body').lpModal({
			onInit: true,
			content: $('#pnlCouponOverlay'),
			height: 285,
			width: this.canShowPromoTermsConditions() ? 800 : 476,
			appendContentToForm: false,
			openEvt () {

				// fire GA event for show terms
				trackCartEvents({ eventAction: 'click-Coupon-Terms' });

				if (promoCodeCartSiteMode) {

					setGenericEvent({
						event_name: 'cart_promo_terms_click'
					});

				}

				if (!that.model.get('promoCodeError')) {

					// fetch Coupon T&C on demand
					const promoCode = that.model.get('SelectedPromoCode');
					if (promoCode) {

						const request = GetPromoCodeTerms(promoCode).then((response) => {

							if (response.operationSuccess) {

								$('#lpModalContent #couponSmallPrint').html(
									response.GlobalCartResponseModel.TermsConditions
								);
								$('#lpModalContent #endDate').html(response.GlobalCartResponseModel.EndDate);

							} else {

								showCartErrorMessage({
									response,
									fromModal: true
								});

							}

						});
						$(cart).trigger('indicateLoad', request);

					}

				}

				$('#pnlCouponOverlay .dismissCouponError').on('click', (e) => {

					e.preventDefault();
					$('body').lpModalClose();

				});

			}
		});

	}
});

export default PromoCodeTermsAndConditionsLink;
